export default "__VITE_ASSET__a8d5632a__"